export const ARTICLES_VIEWED_STORAGE_KEY = 'articles_viewed';
